module.exports = __webpack_public_path__ + "media/images/application/template/spacer-5575162f58ea4570e78d7430ba5dabc4.gif";